module.exports = __webpack_public_path__ + "img/img.77c6c8c1.jpg";